export default function Mark() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M7.99922 0.449219C3.82422 0.449219 0.449219 3.82422 0.449219 7.99922C0.449219 12.1742 3.82422 15.5742 7.99922 15.5742C12.1742 15.5742 15.5742 12.1742 15.5742 7.99922C15.5742 3.82422 12.1742 0.449219 7.99922 0.449219ZM7.99922 14.4492C4.44922 14.4492 1.57422 11.5492 1.57422 7.99922C1.57422 4.44922 4.44922 1.57422 7.99922 1.57422C11.5492 1.57422 14.4492 4.47422 14.4492 8.02422C14.4492 11.5492 11.5492 14.4492 7.99922 14.4492Z"
        fill="#8899A8"
      />
      <path
        d="M10.1497 5.67436L7.17475 8.57436L5.82475 7.24936C5.59975 7.02436 5.24975 7.04936 5.02475 7.24936C4.79975 7.47436 4.82475 7.82436 5.02475 8.04936L6.62475 9.59936C6.77475 9.74936 6.97475 9.82436 7.17475 9.82436C7.37475 9.82436 7.57475 9.74936 7.72475 9.59936L10.9497 6.49936C11.1747 6.27436 11.1747 5.92436 10.9497 5.69936C10.7247 5.47436 10.3747 5.47436 10.1497 5.67436Z"
        fill="#8899A8"
      />
    </svg>
  );
}
